import { TDropItem } from "src/types";

export const processStatusOptions: TDropItem[] = [
  { value: "submitted", label: "Ready to Process" },
  { value: "processing", label: "Under Review" },
  { value: "reopen", label: "Waiting for user to resubmit info" },
  { value: "qcReadyVetting", label: "QC Vetting Approved" },
  { value: "qcReadyReopen", label: "QC Need More Info" },
  { value: "qcReadyRejected", label: "QC Rejected" },
  { value: "rejected", label: "Rejected" },
  { value: "appeal", label: "Pending Appeal" },
  { value: "deactivationApproval", label: "Pending Deactivation Approval" },
  { value: "international", label: "Pending International" },
  { value: "testSecurity", label: "Pending Test Security" },
  { value: "xpmDenied", label: "XPM Denied" },
  { value: "opsApproved", label: "Vetting Approved" },
  { value: "completed", label: "Completed" },
];
